module.exports = __webpack_public_path__ + "static/media/individualChart.9ad93d02.png";